import { useEffect, useState } from 'react';
import { ZoomOut } from 'lucide-react';

/**
 * Pinch-zoom (two fingers on a touchpad) magnifies the page without
 * re-laying it out, so parts of the editor look cut off. Detect it via the
 * Visual Viewport API and show a hint pinned to the visible area.
 */
export function ZoomHint() {
  const [view, setView] = useState<{ scale: number; left: number; top: number; width: number } | null>(null);

  useEffect(() => {
    const vv = window.visualViewport;
    if (!vv) return;
    const update = () => setView(vv.scale > 1.05 ? { scale: vv.scale, left: vv.offsetLeft, top: vv.offsetTop, width: vv.width } : null);
    update();
    vv.addEventListener('resize', update);
    vv.addEventListener('scroll', update);
    return () => {
      vv.removeEventListener('resize', update);
      vv.removeEventListener('scroll', update);
    };
  }, []);

  if (!view) return null;
  return (
    <div
      role="status"
      data-testid="zoom-hint"
      style={{
        position: 'fixed', zIndex: 100, left: view.left, top: view.top, width: view.width * view.scale,
        transform: `scale(${1 / view.scale})`, transformOrigin: 'top left', padding: 8,
      }}
    >
      <div className="notice notice--warning" style={{ boxShadow: '0 6px 20px rgb(0 0 0 / 0.35)' }}>
        <ZoomOut size={16} />
        <span>
          The page is magnified (pinch-zoom), so parts of the editor are hidden. Pinch out with two fingers on your
          touchpad, or reload the page, to see everything.
        </span>
      </div>
    </div>
  );
}
